import React from "react";
import SEO from "../components/common/SEO";

const Satzung = () => (
  <div className="py-12 bg-gray-50 min-h-screen">
    <SEO 
      title="Satzung - Deutsch-Arabischer Bildungsverein e.V."
      description="Satzung des Deutsch-Arabischen Bildungsverein e.V."
    />
    <div className="container mx-auto px-4 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6 text-center">Satzung</h1>
      <div className="prose prose-gray">
        <h2>1 – Name und Sitz des Vereines</h2>
        <p>
          Der Verein führt den Namen <strong>Deutsch-Arabischer Bildungsverein  e.V.</strong><br />
          Er hat seinen Sitz in Braunschweig, Im Gettelhagen 80, 38108 Braunschweig und soll ins Vereinsregister im Amtsgericht Braunschweig eingetragen werden.
        </p>

        <h2>2 – Zweck des Vereins</h2>
        <p>
          Der Verein verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne des Abschnitts „Steuerbegünstigte Zwecke“ der Abgabenordnung.
        </p>
        <p>
          Der Satzungszweck wird verwirklicht insbesondere durch folgende Maßnahmen:
        </p>
        <p>
          Der Zweck des Vereins ist die Förderung der Jugendhilfe sowie die Förderung der Erziehung, Volks- und Berufsbildung einschließlich der Studentenhilfe.
        </p>
        <p>
          Der Satzungszweck wird verwirklicht insbesondere durch folgende Maßnahmen:
        </p>
        <ul>
          <li>Die pädagogische sowie humanitär-gesundheitliche Hilfe insbesondere für Kinder, Jugendliche und Studenten aus dem arabischen Raum. Vornehmlich in Spannungsgebieten verfolgt der Verein das Ziel Bildungs- und Gesundheitseinrichtungen im weitesten Sinne finanziell als auch materiell zu unterstützen.</li>
          <li>Ferner verfolgt der Verein die Ausschreibung von Studien- und Forschungsstipendien an deutschen Universitäten, Bildungsstätten und Gesundheitseinrichtungen.</li>
          <li>Die Förderung erstreckt sich auch auf die Schulung und Ausbildung von Lehrpersonal- sowie Aufbau von Forschungseinrichtungen vor Ort in den Zielländern.</li>
        </ul>
        <p>
          Der Verein ist selbstlos tätig; er verfolgt nicht in erster Linie eigenwirtschaftliche Zwecke. Mittel des Vereins dürfen nur für die satzungsmäßigen Zwecke verwendet werden. Die Mitglieder erhalten keine Zuwendungen aus Mitteln des Vereins. Es darf keine Person durch Ausgaben, die dem Zweck des Vereins fremd sind, oder durch unverhältnismäßig hohe Vergütungen begünstigt werden. Alle Inhaber von Vereinsämtern sind ehrenamtlich tätig.
        </p>
        <p>
          Jeder Beschluss über die Änderung der Satzung ist vor dessen Anmeldung beim Registergericht dem zuständigen Finanzamt vorzulegen. Die Erfüllung des Vereinszweckes geschieht ohne Bevorzugung einer politischen oder konfessionellen Richtung.
        </p>

        <h2>3 – Mitglieder</h2>
        <p>
          Der Verein besteht aus aktiven und fördernden Mitgliedern. Mitglied kann jede Person sein. Förderndes Mitglied kann jede natürliche oder juristische Person sein, die die Bestrebungen des Vereins unterstützen will.
        </p>
        <p>
          Um die Aufnahme in den Verein ist beim Vorstand schriftlich nachzusuchen.
        </p>
        <p>
          Über die Aufnahme entscheidet der Vorstand. Lehnt dieser den Aufnahmeantrag ab, so steht dem Betroffenen die Berufung zur Mitgliederversammlung zu. Diese entscheidet endgültig.
        </p>

        <h2>4 – Beendigung der Mitgliedschaft</h2>
        <p>
          Die Mitgliedschaft endet
        </p>
        <ul>
          <li>a) durch freiwilligen Austritt,</li>
          <li>b) durch Tod,</li>
          <li>c) durch Ausschluss.</li>
        </ul>
        <p>
          Der freiwillige Austritt erfolgt durch schriftliche Erklärung gegenüber dem Vorstand unter Einhaltung einer halbjährigen Kündigungsfrist zum Schluss eines Kalenderjahres. Bis zu diesem Zeitpunkt bleibt das ausscheidende Mitglied zur Bezahlung des Mitgliedsbeitrages verpflichtet.
        </p>
        <p>
          Der Tod einer Person als Mitglied bewirkt das sofortige Ausscheiden.
        </p>
        <p>
          Ein Mitglied kann, wenn es gegen die Vereinsinteressen gröblich verstoßen hat, mit sofortiger Wirkung durch den Vorstand ausgeschlossen werden. Vor der Beschlussfassung ist dem Mitglied unter Setzung einer angemessenen Frist Gelegenheit zur Rechtfertigung zu geben. Der Beschluss über den Ausschluss ist mit Gründen zu versehen und dem Mitglied mittels eingeschriebenen Briefes bekannt zu machen. Gegen den Beschluss steht dem Mitglied die Berufung zur Mitgliederversammlung zu. Die Berufung muss innerhalb einer Frist von einem Monat ab Zugang des eingeschriebenen Briefes beim Vorstand eingelegt werden. Die Mitgliederversammlung, die über die Berufung entscheidet, ist innerhalb von zwei Monaten nach Eingang der Berufungsschrift einzuberufen. Macht ein Mitglied von der Berufung keinen Gebrauch, so unterwirft es sich damit dem Ausschließungsbeschluss mit der Folge, dass eine gerichtliche Anfechtung nicht mehr möglich ist.
        </p>

        <h2>5 – Pflichten der Mitglieder</h2>
        <p>
          Alle Mitglieder haben die Interessen des Vereins zu fördern. Jedes Mitglied ist verpflichtet, den von der Mitgliederversammlung festgesetzten Beitrag pünktlich zu entrichten. Gleiches gilt für den von der Mitgliederversammlung aus besonderen Anlass beschlossenen Umlagesatz.
        </p>

        <h2>6 – Verwendung der Finanzmittel</h2>
        <p>
          Mitgliedsbeiträge und andere Zuwendungen dienen allein den beschriebenen Zwecken des Vereins. Nicht mit dem angegebenen Zweck zu vereinbarende Zuwendungen oder unangemessene Vergütungen dürfen aus Vereinsmitteln weder an Mitglieder noch an andere Personen gewährt werden.
        </p>

        <h2>7 – Organe des Vereins</h2>
        <p>
          Organe des Vereins sind
        </p>
        <ul>
          <li>a) die Mitgliederversammlung</li>
          <li>b) der Vorstand</li>
        </ul>

        <h2>8 – Die Mitgliederversammlung</h2>
        <p>
          Die Mitgliederversammlung ist mindestens einmal im Laufe eines Jahres durch den Vorstand einzuberufen, im Übrigen dann, wenn mindestens ein Drittel der Mitglieder dies beantragt.
        </p>
        <p>
          Eine Mitgliederversammlung ist vierzehn Tage vorher unter Bekanntgabe der Tagesordnung schriftlich einzuberufen. Die ordnungsgemäß einberufene Mitgliederversammlung ist ohne Rücksicht auf die erschienene Anzahl der Mitglieder beschlussfähig.
        </p>
        <p>
          Die Mitgliederversammlung wird vom ersten Vorsitzenden oder dessen Vertreter geleitet.
        </p>
        <p>
          Alle Beschlüsse, mit Ausnahme des Beschlusses der Auflösung des Vereins, werden mit einfacher Stimmenmehrheit gefasst und durch den Schriftführer protokolliert.
        </p>
        <p>
          Stimmberechtigt sind alle Mitglieder. Stimmengleichheit gilt als Ablehnung.
        </p>
        <p>
          Die Mitgliederversammlung hat folgend Aufgaben:
        </p>
        <ul>
          <li>a) Feststellung, Abänderung und Auslegung der Satzung;</li>
          <li>b) Entgegennahme des Jahresberichts und der Jahresabrechnung des Vorstandes;</li>
          <li>c) Wahl des Vorstandes;</li>
          <li>d) Wahl von zwei Rechnungsprüfern auf die Dauer von 2 Jahren;</li>
          <li>e) Festsetzung des Mitgliederbeitrages;</li>
          <li>f) Genehmigung der Jahresrechnung und Entlastung des Vorstandes;</li>
          <li>g) Beschlussfassung über die Auflösung des Vereins;</li>
          <li>h) Entscheidung über die Berufung nach § 3 und § 4 der Satzung;</li>
          <li>i) Ernennung von Ehrenmitgliedern.</li>
        </ul>
        <p>
          Jedem Mitglied steht das Recht zu, Anträge einzubringen. Diese Anträge sind acht Tage vor der Mitgliederversammlung schriftlich und begründet beim Vorstand einzureichen.
        </p>

        <h2>9 – Der Vorstand</h2>
        <p>
          Der Vorstand besteht aus
        </p>
        <ul>
          <li>a) der Vorsitzende, der/dem Vorsitzenden</li>
          <li>b) der/die stellvertretende(n) Vorsitzende(n), der/dem stellvertretenden Vorsitzenden</li>
          <li>c) der Schriftführer, der/dem Schriftführer(in)</li>
          <li>d) der Kassenführer. der/dem Kassenführer(in)</li>
          <li>e) 4 Beisitzer(in)</li>
        </ul>
        <p>
          Der geschäftsführende Vorstand, im Sinne des § 26 BGB, sind:<br />
          Der/die Vorsitzende, stellvertretende(n) Vorsitzende(n), und der/die Schriftführer(in). Jedes dieser Vorstandsmitglieder ist gerichtlich und außergerichtlich allein vertretungsberechtigt
        </p>
        <p>
          Scheidet ein Mitglied des Vorstandes während der Wahlzeit aus, so übernimmt auf Beschluss des Vorstandes eines der übrigen Mitglieder die Geschäfte des Ausgeschiedenen bis zur satzungsgemäßen Neuwahl des Vorstandes.
        </p>
        <p>
          Der Vorstand wird auf 4 Jahre gewählt.
        </p>
        <p>
          Der Vorstand fasst seine Beschlüsse in Vorstandssitzungen ggf. im Umlaufverfahren, die vom Vorsitzenden oder stellvertretenden Vorsitzenden schriftlich oder mündlich einberufen werden. Die Beschlüsse des Vorstandes sind mit einfacher Mehrheit zu fassen und schriftlich niederzulegen.
        </p>

        <h2>10 – Das Geschäftsjahr</h2>
        <p>
          Das Geschäftsjahr ist das Kalenderjahr.
        </p>

        <h2>11 – Auflösung des Vereins</h2>
        <p>
          Die Auflösung des Vereins kann nur in einer Mitgliederversammlung mit Zustimmung von drei Viertelteilen der erschienenen Mitglieder beschlossen werden. Sofern Die Mitgliederversammlung nichts anderes beschließt, sind der Vorsitzende und der stellvertretende Vorsitzende die gemeinsam vertretungsberechtigten Liquidatoren.
        </p>
        <p>
          Bei Auflösung des Vereins oder bei Wegfall steuerbegünstigter Zwecke fällt das Vermögen des Vereins an die „Technische Universität Braunschweig“. Die es unmittelbar und ausschließlich für gemeinnützige, mildtätige oder kirchliche Zwecke zu verwenden hat.
        </p>
        <p>
          Bei Auflösung oder Aufhebung des Vereins ist das Vermögen zu steuerbegünstigten Zwecken zu verwenden. Beschlüsse über die künftige Verwendung des Vermögens dürfen erst nach Einwilligung des Finanzamtes ausgeführt werden.
        </p>

        <h2>12 – Inkrafttreten</h2>
        <p>
          Die vorliegende Satzung ist in der Mitgliederversammlung vom 14.03.2018 beschlossen worden und mit dem gleichen Tage in Kraft getreten. Der Vorstand kann zur vorliegenden Satzung eine Geschäftsordnung erlassen.
        </p>
      </div>
    </div>
  </div>
);

export default Satzung;
